"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCSPHeaderValue = void 0;
/**
 * Reference: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy
 *
 * Generates the header value for the Content-Security-Policy header, based on the supplied PolicyDirectives.
 *
 * The preferred CSP delivery mechanism is through the HTTP header. It can be useful, however,
 * to set a policy on a page directly in the markup using a <meta> tag with an http-equiv attribute;
 * See: https://developers.google.com/web/fundamentals/security/csp#the_meta_tag
 *
 * Example usage:
 *
 * const directives = {
 *   "connect-src": ["val1", "val2"],
 *   "img-src": ["val3"]
 * }
 *
 * const cspHeader = generateCSPHeaderValue(directives)
 *
 * If using the meta approach you'd then supply it like so;
 *
 * <meta httpEquiv="Content-Security-Policy" content={cspHeader} />
 *
 * Note: The meta tag approach can't be used for frame-ancestors, report-uri, or sandbox.
 *
 * @param policyDirectives the directives/values pairs
 */
function generateCSPHeaderValue(policyDirectives) {
    return Object.entries(policyDirectives)
        .map(([directive, values]) => `${directive} ${values.join(" ")}`)
        .join("; ");
}
exports.generateCSPHeaderValue = generateCSPHeaderValue;
//# sourceMappingURL=contentSecurity.js.map